import React from "react";
import "./Coaches.scss";
import ruslan from './img/ruslan1.jpg'
import bxoing from './img/AleksandrA.png'
import robert from './img/robert.jpg'
import Glebs from './img/Glebs.png'

const COACHES = [
  {
    name: "Ruslans Okurļaks",
    role: "Galvenais treneris",
    bio: "20+ gadu pieredze taolu un sanda. Sagatavojis Latvijas un Baltijas čempionus.",
    img: ruslan
  },
  {
    name: "Coach Gļebs",
    role: "K-1",
    bio: "Strādā ar jaunākajām grupām, veido pamatus caur spēlēm un disciplīnu.",
    img: Glebs
  },
  {
    name: "Roberts Skujins",
    role: "MMA",
    bio: "Atbild par fizisko sagatavotību, sparingu un drošību kontaktā.",
    img: robert
  },
  {
    name: "Aleksandrs Aleksejenko",
    role: "Boxing",
    bio: "Atbild par fizisko sagatavotību, sparingu un drošību kontaktā.",
    img: bxoing
  },
];

export default function Coaches() {
  return (
    <section id="coaches" className="section">
      <div className="container">
        <header className="section__head">
          <h2>Treneri</h2>
          <p className="muted">Sertificēti speciālisti ar pieredzi sacensībās un darbā ar bērniem.</p>
        </header>
        <div className="coaches">
          {COACHES.map((c) => (
            <article key={c.name} className="coach">
              <img src={c.img} alt={c.name} loading="lazy" />
              <div className="coach__body">
                <h3>{c.name}</h3>
                <p className="coach__role">{c.role}</p>
                <p className="muted">{c.bio}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
